<div class="icon" [style.border-color]="unitType?.color">
  <figma-icon [name]="unitType?.icon"></figma-icon>
</div>
